import React from "react";
import { ExpenseCategoryComponent } from "./ExpenseCategory.Component";
import { httpServices } from "../../../services/httpServices";
import { CustomProgressBar } from "../../common/CustomProgressBar";
import { ErrorPage } from "../../common/error";

const filterFields = {
    report_status: 0,
    employee: 0,
    name_format: "FIRSTLAST",
    startDate: null,
    endDate: null,
};

const formFields = {
    id: 0,
    name: "",
    status: 1,
    description: "",
    declaration: "",
};

export class ExpenseCategoryContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasPermission: true,
            categoryList: [],
            filterFields: filterFields,
            showLoader: false,
            errors: {},
            popupType: "add",
            deleteCategoryId: 0,
            formFields: formFields,
            open: false,
            isEditable: false,
            statuses: [],
            snackbarOpen: false,
            snackbarMsg: "",
            snackbarVarient: "success",
            editPermission: false,
            deletePermission: false,
        };

        this.getCategoryList = this.getCategoryList.bind(this);
        this.editCategoryClick = this.editCategoryClick.bind(this);
        this.deleteCategoryClick = this.deleteCategoryClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onAddCategoryClick = this.onAddCategoryClick.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
    }

    componentDidMount = () => {
        this.getCategoryList();
    };

    getCategoryList = (sdate, props) => {
        this.setState({
            showLoader: true,
        });

        let apiEndpoint = "api/settings/expenses/expenseCategories";

        return httpServices
            .post(apiEndpoint)
            .then((response) => {
                let response_data = response.data;

                if (response_data.permission === false) {
                    this.setState({
                        hasPermission: false,
                        showLoader: false,
                    });
                } else {
                    this.setState({
                        categoryList: response_data.categories,
                        showLoader: false,
                        statuses: response_data.statuses,
                        deletePermission:
                            response_data.delete_permission,
                        editPermission:
                            response_data.edit_permission,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    };

    editCategoryClick = (id) => () => {
        let apiEndpoint =
            "api/settings/expenses/getCategoryById";

        return httpServices
            .post(apiEndpoint, { id: id })
            .then((response) => {
                if (response.data) {
                    if (response.data.category_details) {
                        this.setState({
                            formFields:
                                response.data.category_details,
                            open: true,
                            isEditable: true,
                            popupType: "add",
                            statuses: response.data.statuses,
                        });
                    }
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    };

    handleValidation() {
        let formIsValid = true;
        let errors = {};

        if (!this.state.formFields.name.trim()) {
            errors["name"] = "Cannot be empty";
            formIsValid = false;
        }

        if (!this.state.formFields.description) {
            errors["description"] = "Cannot be empty";
            formIsValid = false;
        }

        this.setState({
            errors: errors,
        });

        return formIsValid;
    }

    handleSubmit = (event) => {
        if (this.handleValidation()) {
            let data = this.state.formFields;

            if (data) {
                httpServices
                    .post(
                        "api/settings/expenses/saveCategory",
                        { data }
                    )
                    .then((response) => {
                        if (response.data.success) {
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg:
                                    response.data.success_message,
                                categoryList:
                                    response.data.categories,
                                open: false,
                                snackbarVarient: "success",
                            });
                        } else {
                            this.setState({
                                errors: response.data.errors,
                                showLoader: false,
                                categoryList:
                                    response.data.categories,
                                open: false,
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log("error" + error);
                    });
            }
        }
    };

    deleteCategoryClick = (id) => () => {
        if (id) {
            this.setState({
                open: true,
                popupType: "delete",
                deleteCategoryId: id,
            });
        }
    };

    deleteCategory = () => {
        let del_id = this.state.deleteCategoryId;

        if (del_id) {
            let apiEndpoint =
                "api/settings/expenses/deleteCategory";

            return httpServices
                .post(apiEndpoint, { id: del_id })
                .then((response) => {
                    if (response.data.success) {
                        this.setState({
                            snackbarOpen: true,
                            snackbarMsg:
                                response.data.success_message,
                            categoryList:
                                response.data.categories,
                            open: false,
                            snackbarVarient: "success",
                        });
                    } else {
                        this.setState({
                            errors: response.data.errors,
                            showLoader: false,
                            categoryList:
                                response.data.categories,
                            open: false,
                        });
                    }
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });
        }
    };

    onClose = () => {
        this.setState({
            open: false,
            errors: {},
        });
    };

    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formFields;

        ff[field] = evt.target.value;

        this.setState({
            formFields: ff,
        });
    };

    onAddCategoryClick = () => {
        let formFields = {
            id: 0,
            name: "",
            status: 1,
            description: "",
            declaration: "",
        };

        this.setState({
            open: true,
            formFields: formFields,
            isEditable: false,
            popupType: "add",
        });
    };

    snackbarClose = () => {
        this.setState({
            snackbarOpen: false,
        });
    };

    render() {
        return (
            <>
                <CustomProgressBar
                    loaderOpen={this.state.showLoader}
                />

                {this.state.hasPermission ? (
                    <ExpenseCategoryComponent
                        CategoryList={
                            this.state.categoryList
                        }
                        EditCategoryClick={
                            this.editCategoryClick
                        }
                        DeleteCategoryClick={
                            this.deleteCategoryClick
                        }
                        GetCategoryList={
                            this.getCategoryList
                        }
                        PopupType={this.state.popupType}
                        DeleteCategoryId={
                            this.state.deleteCategoryId
                        }
                        Open={this.state.open}
                        IsEditable={this.state.isEditable}
                        FormFields={this.state.formFields}
                        OnClose={this.onClose}
                        HandleSubmit={this.handleSubmit}
                        Errors={this.state.errors}
                        OnAddCategoryClick={
                            this.onAddCategoryClick
                        }
                        HandleOnChange={
                            this.handleOnChange
                        }
                        Statuses={this.state.statuses}
                        DeleteCategory={
                            this.deleteCategory
                        }
                        SnackbarOpen={
                            this.state.snackbarOpen
                        }
                        SnackbarMsg={
                            this.state.snackbarMsg
                        }
                        SnackbarVarient={
                            this.state.snackbarVarient
                        }
                        SnackbarClose={
                            this.snackbarClose
                        }
                        EditPermission={
                            this.state.editPermission
                        }
                        DeletePermission={
                            this.state.deletePermission
                        }
                    />
                ) : (
                    <ErrorPage />
                )}
            </>
        );
    }
}
